export default __webpack_public_path__ + "static/media/1_1.2fc47b84.jpg";